import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-comingsoon',
    templateUrl: './comingsoon.component.html',
    styleUrls: ['./comingsoon.component.scss'],
    standalone: false
})

/**
 * Coming-soon component
 */
export class ComingsoonComponent implements OnInit {

  constructor() { }
  private _diff: number;
  _days: number;
  _hours: number;
  _minutes: number;
  _seconds: number;
  private _trialEndsAt;

  ngOnInit(): void {
    this._trialEndsAt = "2021-12-31";

    interval(1000).pipe(
      map((x) => {
        this._diff = Date.parse(this._trialEndsAt) - Date.parse(new Date().toString());
      })).subscribe((x) => {
        this._days = this.getDays(this._diff);
        this._hours = this.getHours(this._diff);
        this._minutes = this.getMinutes(this._diff);
        this._seconds = this.getSeconds(this._diff);
      });
  }
  
  getDays(t) {
    return Math.floor(t / (1000 * 60 * 60 * 24));
  }

  getHours(t) {
    return Math.floor((t / (1000 * 60 * 60)) % 24);
  }

  getMinutes(t) {
    return Math.floor((t / 1000 / 60) % 60);
  }

  getSeconds(t) {
    return Math.floor((t / 1000) % 60);
  }
}
